export default {"src":"/_next/static/media/payment_history_phone.ce4c3984.svg","height":213,"width":250};